<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:21:26
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:15:01
-->
<template>
    <div>
        <div class="top">
            <div class="top-btn">
            <el-button  v-if="codeData.indexOf('295') != -1"  @click="add"  type="primary">新增问卷</el-button>            
            </div>
            <div class="search">
            <a-input
                v-model:value="seachValue"
                placeholder="请输入标题搜索"
                style="width: 173px; margin-right: 12px"
            />
            </a-input-group>
                 <el-button  @click="search" type="primary" 
                >查询</el-button 
                >
            </div>
        </div>
        <coententTable
        @onShowSizeChange="onShowSizeChange"
        :columns="columns"
        :pagination="pagination"
        :dataSource="dataSource"
        :customSlot="customSlot"
        :loading="loading"
        :y="height"
        @handleSizeChange="handleSizeChange"
        >   
            <template v-slot:collectStartTime="scopeVal">
                <div >
                {{scopeVal.scope.questionnaireStartTime}} 至 {{scopeVal.scope.questionnaireEndTime}}
                </div>
            </template>
            <template v-slot:collectStatus="scopeVal">
                <div :class="[scopeVal.scope.questionnaireStatus == 2?'collectStatus1':scopeVal.scope.questionnaireStatus == 1?'collectStatus2':'']">
                {{
                    scopeVal.scope.questionnaireStatus == 1
                    ? "未开始"
                    : scopeVal.scope.questionnaireStatus == 2
                    ? "进行中"
                    : "已结束"
                }}
                </div>
            </template>
            <template v-slot:logo="scopeVal">
                <a-popover trigger="click">
                    <div class="content" slot="content">
                        <div style="font-size:16px;margin-bottom: 10px;">发布信息</div>
                        <div class="open-style" v-for="(item, index) in seeData" :key="index">
                            <div>发布人: {{ item.managementName || "--" }}</div>
                            <div>发布时间: {{ item.operateTime || "--" }}</div>
                        </div>
                    </div>
                    <a   v-if="codeData.indexOf('293') != -1" @click="seeLogo(scopeVal.scope.id)">查看</a>
                </a-popover>
            </template>
            <template v-slot:displayStatus="scopeVal">
                <a-switch   :disabled="!scopeVal.scope.type"  v-if="codeData.indexOf('294') != -1" :v-model="scopeVal.scope.displayStatus" :checked="scopeVal.scope.displayStatus?true:false" @change="checked=> changeDisplayStatus(checked, scopeVal.scope.id)" />
            </template>
            <template v-slot:operation="scopeVal">
                 <div style="display: flex">
                     <div
                        v-if="codeData.indexOf('297') != -1"
                        @click="toDetails(scopeVal.scope.id)"
                        style="margin-right: 14px;width:66px"
                        class="btnTwo"
                        >详细信息</div
                        >
                        <div
                        v-if="codeData.indexOf('298') != -1"
                        @click="open(scopeVal.scope)"
                        class="btnThree"
                        >删除</div
                        >
                 </div>
               
            </template>
        </coententTable>
        <el-dialog
            title="确认删除该问卷调查？"
            :visible.sync="dialogVisibleTwo"
            width="450px"
            custom-class="tips-box"
            :before-close="handleClose"
            top="17%"
            >
            <span
                >删除后，网站中将不再显示该征集调查内容，以及相关的意见清单和结果反馈等，请谨慎删除。</span
            >
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleTwo = false">取消</el-button>
                <el-button :loading="deleteShow" type="danger" @click="deleteOne()"
                >确认删除</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {findListPage,collectDelete,updateDisplayStatus,findLogList} from "./index.js";
export default {
    components: {
        coententTable
    },
    data(){
        return{
            seachValue:'',
            columns: [
                {
                    title: "问卷标题",
                    dataIndex: "questionnaireTheme",
                    ellipsis: true,
                     customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
                },
                {
                    title: "问卷时间",
                    dataIndex: "collectStartTime",
                    ellipsis: true,
                    width: 400,
                    scopedSlots: { customRender: "collectStartTime" },
                },
                {
                    title: "问卷状态",
                    dataIndex: "questionnaireStatus",
                    scopedSlots: { customRender: "collectStatus" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "发布日志",
                    dataIndex: "logo",
                    scopedSlots: { customRender: "logo" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "是否显示",
                    dataIndex: "displayStatus",
                    scopedSlots: { customRender: "displayStatus" },
                    ellipsis: true,
                    width: 120,
                },
                {
                    title: "操作",
                    dataIndex: "operate",
                    scopedSlots: { customRender: "action" },
                    fixed: "right",
                    width: 200,
                },
            ],
            pagination: {
                current: 1,
                pageSize: 15,
                total: 0,
                pageSizeOptions: ["15", "25", "35"],
            },
            dataSource: [],
            customSlot: [
                {
                    name: "displayStatus",
                    customRender: "displayStatus",
                },
                {
                    name: "collectStatus",
                    customRender: "collectStatus",
                },
                {
                    name: "logo",
                    customRender: "logo",
                },
                {
                    name: "collectStartTime",
                    customRender: "collectStartTime",
                }
            ],
            loading: false,
            height:0,
            collectTheme:'',//
            collectUnit:'',
            dialogVisibleTwo:false,
            item:{},
            seeData:[],
            codeData:[],
            deleteShow:false,
        }
    },
    mounted(){
        
        this.getListPage()
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    },
    methods: {
        add() {
            sessionStorage.removeItem('wenjuanCollectId');
            this.$router.push({
                path: "/index/questionnaire/add",
                query: { 
                    title: "新增问卷",
                    isEdit: false,
                    islast:true,
                },
            });
        },
        openAddPage(){

        },
        open(item){
            this.item = JSON.parse(JSON.stringify(item))
            this.dialogVisibleTwo = true;
        },
        handleClose(){
            this.dialogVisibleTwo = false
        },
        search(){
            this.pagination.current = 1;
            this.getListPage()
        },
        onShowSizeChange(current) {
            this.pagination.current = current;
            this.getListPage();
        },
        handleSizeChange(pageSize){
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getListPage();
        },
        getListPage(){
            const _this = this
            _this.loading = true;
            let reqData = {
               questionnaireTheme:this.seachValue,
                current:_this.pagination.current,
                siteId:sessionStorage.getItem("siteId"),
                size:_this.pagination.pageSize
            }
            findListPage(reqData).then(res=>{
                if(res.code == 0){
                    _this.dataSource = res.data.records
                    _this.pagination.current = res.data.current
                    _this.pagination.total = res.data.total
                    if( _this.pagination.total > 0){
                        this.height = document.documentElement.clientHeight - 370;
                        window.onresize = () => {
                        return (() => {
                            this.height = document.documentElement.clientHeight - 370;
                        })();
                        };
                    }
                    _this.pagination.pageSize = res.data.size
                    _this.loading = false;
                }
            })
        },
        changeDisplayStatus(displayStatus,id){
            updateDisplayStatus({displayStatus:displayStatus?1:0,id:id}).then(res=>{
                if(res.code == 0){
                    this.getListPage()
                }
            })
        },
        deleteOne(){
            this.deleteShow = true;
            collectDelete({id:this.item.id}).then((res)=>{
                if(res.code == 0){
                    this.dialogVisibleTwo = false;
                    this.getListPage()
                }
                this.deleteShow = false;
            })
        },
        seeLogo(id){
            console.log('sdasd')
           findLogList({id:id}).then(res=>{
               if(res.code == 0){
                   this.seeData = JSON.parse(JSON.stringify(res.data))
               }
           })
        },
        toDetails(id){
            sessionStorage.removeItem('wenjuanCollectId')
            this.$router.push({
                path: "/index/questionnaire/details",
                query: {
                    isCollectId: id,
                    isEdit: true,
                    islast:true,
                    title:'详细信息'
                },
            });
        }
    },
};
</script>

<style lang="less" scoped>
    .top {
        width: 100%;
        padding: 24px;
        border-bottom: solid #E4E7ED 1px;
        display: flex;
        justify-content: space-between;
        .search {
            display: flex;
            width: 250px;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
        
        .add-img {
            margin-top: -2px;
            margin-right: 3px;
        }
    }
    .collectStatus1{
        color: #1890ff;
    }
    .collectStatus2{
        color: #909399;
    }
    /deep/.ant-switch-checked{
        background-color: #39d362;
    }
    /deep/ .el-dialog__title{
        font-weight: 600;
    }
    /deep/ .el-dialog__headerbtn{
        font-weight: 600;
        font-size: 22px;
    }
    .btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
  .el-button--primary {
  background: #176de6;
}
</style>